import { render, staticRenderFns } from "./MarkdownComment.vue?vue&type=template&id=fa526220&scoped=true"
import script from "./MarkdownComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MarkdownComment.vue?vue&type=style&index=0&id=fa526220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa526220",
  null
  
)

export default component.exports